import { Box, Flex, Text, Button, Heading, IconButton, Grid, Card, AlertDialog, Container, Separator, Badge } from '@radix-ui/themes';
import { PlusIcon, Pencil1Icon, Cross2Icon, ExclamationTriangleIcon, ComponentBooleanIcon, CalendarIcon } from '@radix-ui/react-icons';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { getTeacherCourseDetails } from '../../api/courses';
import LoadingIndicator from '../../components/shared/LoadingIndicator';
import CreateTeachingPlan from '../forms/teacher/CreateTeachingPlan';
import TeacherSubscriptions from './TeacherSubscriptions';
import { DateTime } from 'luxon';

const TeacherCourse = () => {
    // console.log('course', course);
    // const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showTeachingPlanDialog, setShowTeachingPlanDialog] = useState(false);
    const [courseData, setCourseData] = useState(null);
    const location = useLocation();
    const courseInfo = location.state?.course;
    const user = useSelector(state => state.user);
    const { courseId } = useParams();
    console.log('courseId', courseId);
    const course = useSelector(state => state.teacherAccount.courses.find(c => c.id === parseInt(courseId)));
    const account = useSelector(state => state.account);

    console.log('Course from location', useSelector(state => state.teacherAccount.courses));



    useEffect(() => {
        getCourseData();
    }, []);

    useEffect(() => {
        console.log('courseData', courseData);
    }, [courseData]);

    const handleTeachingPlanCreated = (teachingPlan) => {
        const plans = courseData.teaching_plans;
        setCourseData({ ...courseData, teaching_plans: [...plans, teachingPlan] });
        setShowTeachingPlanDialog(false);
    }

    const getCourseData = async () => {
        setLoading(true);
        try {
            const response = await getTeacherCourseDetails(courseId);
            setCourseData(response.course);
            console.log('Course', response.course);
        } catch (error) {
            console.error('Error fetching course data', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getCourseData();
    }, []);

    useEffect(() => {
        console.log('courseData', courseData);
    }, [courseData]);


    const renderActiveTeachingPlan = () => {
        if (course?.active_teaching_plan) {
            return (
                <Flex direction="row" gap="6" justify="start" align="center" wrap="wrap">

                    <Flex direction="column" gap="2" align="start">
                        <Flex direction="row" justify="start" gap="2" align="start">
                            <ComponentBooleanIcon /><Text size="1" className="body-label">Plan</Text>
                            <Text size="1" as="p" weight="bold">{course.active_teaching_plan.academic_year} | {course.active_teaching_plan.title}</Text>
                        </Flex>
                        <Flex direction="row" justify="start" gap="2" align="start">
                            <ComponentBooleanIcon /><Text size="1" className="body-label">Status</Text>
                            <Badge color="mint" variant="surface">{course.active_teaching_plan.status}</Badge>
                        </Flex>
                    </Flex>
                    <Flex direction="column" gap="2" align="start">
                        <Flex direction="row" gap="2" align="center">
                            <CalendarIcon width="16" height="16" /><Text size="1" as="p" className="body-label">Start Date</Text><Text size="1" as="p">{DateTime.fromISO(course.active_teaching_plan.start_date).toLocaleString(DateTime.DATE_SHORT)}</Text>
                        </Flex>
                        <Flex direction="row" gap="2" align="center">
                            <CalendarIcon width="16" height="16" /><Text size="1" as="p" className="body-label">End Date</Text><Text size="1" as="p">{DateTime.fromISO(course.active_teaching_plan.end_date).toLocaleString(DateTime.DATE_SHORT)}</Text>
                        </Flex>
                    </Flex>
                    <Box direction="row" gap="2" align="end">
                        <Text size="8">
                            {course.progress_percentage}
                        </Text>
                        <Text size="1">%</Text>
                        <Text as="p" size="1">Completed</Text>
                    </Box>
                </Flex>
            )
        }
        return <Flex direction="row" gap="4" justify="between" align="center">
            <Flex direction="row" gap="2">
                <ExclamationTriangleIcon width="16" height="16" style={{ color: "var(--amber-9)" }} />
                <Text size="1" as="p">An active teaching plan is required to start this course.</Text>
            </Flex>
            <Button variant="soft" size="1" onClick={() => setShowTeachingPlanDialog(true)}>Create Teaching Plan</Button>
        </Flex>;
    }


    if (loading) {
        return <LoadingIndicator />
    }

    return (
        <Box width="100%">
            <Flex direction="column" gap="4">
                <Grid columns="8" gap="4" width="100%">
                    {/* Top card spanning all 8 columns */}
                    {/* <LoadingIndicator /> */}
                    <Box width="100%" style={{ gridColumn: 'span 5' }}>
                        <Card p="4">
                            <Flex direction="column" gap="2">
                                <Flex direction="row" justify="between" align="center">
                                    <Heading size="3">{courseData.level.label} | {courseData.subject.name}</Heading>

                                </Flex>
                            </Flex>
                            <Box size="2" py="2">
                                <Box mb="4" mt="4">
                                    {renderActiveTeachingPlan()}
                                </Box>
                                {courseData?.teaching_plans.length > 0 && (
                                    <>
                                        <Separator size="4" />
                                        <Flex direction="column" gap="2" py="2">
                                            {courseData?.teaching_plans.map((plan) => (
                                                <Flex key={plan.id} direction="row" gap="2" align="center">
                                                    <Text size="1" as="p">{plan.academic_year} | <Text weight="bold" style={{ color: "var(--accent-11)" }}>{plan.title}</Text></Text>
                                                    <Box ml="auto" className="pill" style={{ backgroundColor: plan.status === 'active' ? 'var(--cyan-11)' : 'var(--gray-3)' }}>
                                                        <Text size="1" style={{ color: plan.status === 'active' ? 'var(--gray-1)' : 'var(--green-11)' }}>{plan.status}</Text>
                                                    </Box>
                                                </Flex>
                                            ))}
                                        </Flex>
                                    </>
                                )}
                            </Box>
                        </Card>
                    </Box>

                    {/* Left card spanning 4 columns */}
                    <Box style={{ gridColumn: 'span 3' }}>
                        <Card p="4">
                            <Flex direction="column" gap="2">
                                <Text size="2">Students</Text>
                                <TeacherSubscriptions subscriptions={courseData.subscriptions} />
                                {/* Student list will go here */}
                            </Flex>
                        </Card>
                    </Box>
                </Grid>
            </Flex>
            <AlertDialog.Root open={showTeachingPlanDialog}>
                <AlertDialog.Content maxWidth="95%">
                    <AlertDialog.Title>
                        <Flex justify="between" pt="4" pb="4">
                            <Text as="h3">Create Teaching Plan</Text>
                            <IconButton variant="ghost" onClick={() => setShowTeachingPlanDialog(false)}>
                                <Cross2Icon />
                            </IconButton>
                        </Flex>
                    </AlertDialog.Title>
                    <CreateTeachingPlan course={courseData} onComplete={handleTeachingPlanCreated} onCancel={() => setShowTeachingPlanDialog(false)} />
                </AlertDialog.Content>
            </AlertDialog.Root>
        </Box>
    );
};

export default TeacherCourse;
